const fontTypes = [
  { id: 'HELVETICA', name: 'Helvetica' },
  { id: 'ARIAL', name: 'Arial' },
  { id: 'COURIER_NEW', name: 'Courier New' },
  { id: 'TIMES_NEW_ROMAN', name: 'Times New Roman' },
  { id: 'VERDANA', name: 'Verdana' },
  { id: 'MS_SANS_SERIF', name: 'MS Sans Serif' },
  { id: 'TAHOMA', name: 'Tahoma' }
];

const fontSizes = [
  { id: 6, name: '6 pt' },
  { id: 8, name: '8 pt' },
  { id: 11, name: '11 pt' },
  { id: 12, name: '12 pt' },
  { id: 14, name: '14 pt' },
  { id: 16, name: '16 pt' },
  { id: 18, name: '18 pt' },
  { id: 20, name: '20 pt' },
  { id: 22, name: '22 pt' },
  { id: 24, name: '24 pt' },
  { id: 26, name: '26 pt' },
  { id: 28, name: '28 pt' },
  { id: 30, name: '30 pt' }
];

const textDirection = [
  { id: 'UPPER_LEFT_TO_BOTTOM_RIGHT', name: 'Top Left to Bottom Right' },
  { id: 'BOTTOM_LEFT_TO_UPPER_RIGHT', name: 'Bottom Left to Top Right' },
  { id: 'REPEATING_DIAGONAL', name: 'Repeating Diagonal' }
];

const textPosition = [
  { id: 'TOP_LEFT', name: 'Top Left' },
  { id: 'TOP_MIDDLE', name: 'Top Middle' },
  { id: 'TOP_RIGHT', name: 'Top Right' },
  { id: 'MIDDLE', name: 'Middle' },
  { id: 'BOTTOM_LEFT', name: 'Bottom Left' },
  { id: 'BOTTOM_MIDDLE', name: 'Bottom Middle' },
  { id: 'BOTTOM_RIGHT', name: 'Bottom Right' }
];

const horizontalAlignment = [
  { id: 'LEFT_JUSTIFIED', name: 'Left Justified' },
  { id: 'CENTERED', name: 'Centered' },
  { id: 'RIGHT_JUSTIFIED', name: 'Right Justified' }
];

const fontColors = [
  { name: 'BLACK', code: '#000000' },
  { name: 'RED', code: '#FF0000' },
  { name: 'BLUE', code: '#0000FF' },
  { name: 'ORANGE', code: '#FFA500' },
  { name: 'GREEN', code: '#00FF00' },
  { name: 'GREY', code: '#A0A0A0' }
];

const watermarkCheckboxInclude = [
  { fieldName: 'includeInvestor', label: 'Investor Name' },
  { fieldName: 'includeContactName', label: 'Contact Name' },
  { fieldName: 'includeEmail', label: 'Email Address' },
  { fieldName: 'includeDateTime', label: 'Time Stamp' },
  { fieldName: 'includeIPAddress', label: 'IP Address' }
];

export {
  fontTypes,
  fontSizes,
  textDirection,
  textPosition,
  horizontalAlignment,
  fontColors,
  watermarkCheckboxInclude
};
